module.exports = __webpack_public_path__ + "img/xmas_ac_1.473f644.webp";